import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import axios from "axios";
import { Card, Row, Col, Button, Table, Spin, Typography, Image } from "antd";

const { Title, Text } = Typography;

const OrderDetails = () => {
  const { t } = useTranslation();
  const selectLanguage = i18next.language;
  const [products, setProducts] = useState([]);
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const { id } = useParams();
  const componentRef = useRef();

  const handleToPrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: "Order Details",
    onAfterPrint: () => toast("Print Success"),
  });

  useEffect(() => {
    const getAllProductById = async () => {
      try {
        const userInfo = JSON.parse(localStorage.getItem("customer"));
        const userInfoVendor = JSON.parse(localStorage.getItem("user"));

        const res = await axios.get(
          `${process.env.REACT_APP_APIURL}/vendor/store/customer/getbyidorder/${id}`,
          {
            headers: {
              "Content-type": "application/json",
              Authorization: `Bearer ${userInfo?.token || userInfoVendor?.token}`,
            },
          }
        );

        const response = res.data;

        if (response.status_code === 200 && response.data) {
          setProducts(response.product_details || []);
          setData(response.data);
        } else {
          toast.error("No data found or bad status code.");
        }
      } catch (error) {
        console.error("API error:", error);
        toast.error("Error fetching order details.");
      } finally {
        setLoading(false);
      }
    };
    getAllProductById();
  }, [id]);

  const handleBack = () => {
    window.history.go(-1);
  };

  const columns = [
    {
      title: t("Product"),
      dataIndex: "product_name",
      render: (text, record) => (
        <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
          <Image
            width={64}
            src={record.thumbnail_image || "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRFW55TsH5WO6tvaq2XA1cmgrSD0Z9bZOfM9Q&usqp=CAU"}
            alt="thumbnail"
          />
          <div>
            <Text strong>
              {selectLanguage === "ar" && record.product_name_ar
                ? record.product_name_ar
                : record.product_name}
            </Text>
            <br />
            <Text>
              <strong>Color:</strong>{" "}
              {selectLanguage === "ar" && record.color_name_ar
                ? record.color_name_ar
                : record.color_name}
            </Text>
          </div>
        </div>
      ),
    },
    {
      title: t("Quantity"),
      dataIndex: "product_quantity",
    },
    {
      title: t("Price"),
      render: (_, record) => `Rs ${record.product_quantity * record.product_price}`,
    },
  ];

  if (loading) return <Spin fullscreen size="large" />;

  return (
    <div className="p-4">
      <div ref={componentRef}>
        <Title level={2} className="text-center mb-6">
          {t("Order_Details")}
        </Title>

        <Row gutter={[24, 24]} className="mb-8">
          <Col xs={24} md={12}>
            <Card>
              <p>
                <Text strong>{t("order_table4")}:</Text> {data?.updated_on?.slice(0, 10)}
              </p>
              <p>
                <Text strong>{t("Payment_ID")}:</Text> {data?.transaction_id}
              </p>
              <p>
                <Text strong>{t("l_email")}:</Text> {data?.customer_email}
              </p>
              <p>
                <Text strong>{t("Contact")}:</Text> {data?.customer_contact}
              </p>
            </Card>
          </Col>

          <Col xs={24} md={12}>
            <Card>
              <p>
                <Text strong>{t("Order_Number")}:</Text> {data?.torod_order_id}
              </p>
              <p>
                <Text strong>{t("Quantity")}:</Text> {products?.length}
              </p>
              <p>
                <Text strong>{t("Total_Price")}:</Text> {data?.order_price}
              </p>
              <p>
                <Text strong>{t("Store_Id")}:</Text> {data?.store_id}
              </p>
            </Card>
          </Col>
        </Row>

        <Card title={t("Product Details")}>
          <Table
            columns={columns}
            dataSource={products}
            rowKey={(record, idx) => idx}
            pagination={false}
          />
        </Card>
      </div>

      <div className="flex justify-center mt-8 gap-4">
        <Button onClick={handleBack} type="primary">
          {t("add_new_product_back")}
        </Button>
        <Button onClick={handleToPrint} type="primary">
          {t("Download_Receipt")}
        </Button>
      </div>
    </div>
  );
};

export default OrderDetails;